// extracted by mini-css-extract-plugin
var _1 = "More-modulemore__VIlLS MultiValuedListMoreButton-moduleMultiValuedListMoreButton__uXKl3";
export { _1 as "more" }
